import React from "react";
import { useApp } from "@/context/AppContext";
import { Link } from "react-router-dom";
import { Leaf, MapPin, Clock, Phone, Instagram } from "lucide-react";

export default function Footer() {
  const { t } = useApp();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1B2A22] text-[#FAF7F2] mt-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <img
              src="/icons/icon-192.png"
              alt="İkizler Market"
              className="w-11 h-11 rounded-full border border-white/20"
            />
            <div>
              <p className="font-heading font-extrabold">İkizler Market</p>
              <p className="text-[10px] uppercase tracking-widest text-[#E5A024]">
                Lefke · KKTC
              </p>
            </div>
          </div>
          <p className="text-sm text-[#FAF7F2]/70">{t("tagline_2")}</p>
        </div>

        <div>
          <h4 className="font-heading font-bold mb-3 text-[#E5A024]">
            {t("address_label")}
          </h4>
          <p className="text-sm text-[#FAF7F2]/80 flex gap-2">
            <MapPin className="w-4 h-4 shrink-0 mt-0.5" />
            19 Mayıs Caddesi No: 15/A, Yeni Karadağ / Lefke
          </p>
        </div>

        <div>
          <h4 className="font-heading font-bold mb-3 text-[#E5A024]">
            {t("hours_label")}
          </h4>
          <p className="text-sm text-[#FAF7F2]/80 flex gap-2">
            <Clock className="w-4 h-4 shrink-0 mt-0.5" />
            {t("hours_value")}
          </p>
        </div>

        <div>
          <h4 className="font-heading font-bold mb-3 text-[#E5A024]">İletişim</h4>
          <a
            href="https://wa.me/905391095756"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp"
            className="text-sm text-[#FAF7F2]/80 flex gap-2 hover:text-[#E5A024]"
          >
            <Phone className="w-4 h-4 shrink-0 mt-0.5" />
            +90 539 109 57 56
          </a>
          <a
            href="https://www.instagram.com/ikizlermarketlefke?stkn=dHV5NDY0MG12YjZy"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="text-sm text-[#FAF7F2]/80 flex gap-2 hover:text-[#E5A024] mt-2"
          >
            <Instagram className="w-4 h-4 shrink-0 mt-0.5" />
            @ikizlermarketlefke
          </a>
          <div className="mt-4 flex gap-3 text-xs">
            <Link to="/track" className="hover:text-[#E5A024]">
              {t("nav_track")}
            </Link>
            <Link to="/contact" className="hover:text-[#E5A024]">
              {t("nav_contact")}
            </Link>
            <Link to="/kampanyalar" className="hover:text-[#E5A024]">
              {t("campaigns")}
            </Link>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-[#FAF7F2]/50">
        © {new Date().getFullYear()} İkizler Market · Made with 🌿 in Lefke
      </div>
    </footer>
  );
}
